<!--
  One outlet, always. Two outlets under an @if meant that flipping the signed-in
  flag destroyed the outlet holding the current page and built a fresh one,
  which re-activates the route that is still current (RouterOutlet.ngOnInit
  re-activates from the outlet context). On sign-out the session is already
  cleared by then, so the page was rebuilt with no rights and showed
  "no access" until the sign-in navigation finished loading its chunk.
-->
<app-layout [signedIn]="(isLoggedIn$ | async) ?? false">
  <router-outlet></router-outlet>
</app-layout>

<!--
  Header included: signing in or out replaces the whole shell, and the loader
  standing in for it is cleaner than watching it go piece by piece.
-->
<app-loading-overlay
  [loading]="isAuthPending()"
  [overHeader]="true"
></app-loading-overlay>
